import { 
  addDoc,
  collection,
  doc,
  updateDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../config';
import { auth } from '../firebase';
import type { GenerationData } from './types';

export async function saveGeneration(
  content: string,
  jobDescription: string,
  filters: GenerationData['filters'],
  type: 'letter' | 'resume' | 'recommendation' = 'letter'
): Promise<string> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    const generationData: GenerationData = {
      userID: auth.currentUser.uid,
      content,
      jobDescription,
      filters,
      type,
      timestamp: serverTimestamp()
    };

    const docRef = await addDoc(collection(db, 'generations'), generationData);
    return docRef.id;
  } catch (error) {
    console.error('Error saving generation:', error);
    throw new Error('Failed to save generation');
  }
}

export async function updateGeneration(
  generationId: string,
  newContent: string
): Promise<void> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    const generationRef = doc(db, 'generations', generationId);
    await updateDoc(generationRef, {
      content: newContent,
      lastModified: serverTimestamp()
    });
  } catch (error) {
    console.error('Error updating generation:', error);
    throw new Error('Failed to update generation');
  }
}